module.exports = __webpack_public_path__ + "static/media/ti.c5ab8324.png";